import {
  mdiAlertCircleOutline,
  mdiCheckboxBlankCircleOutline,
  mdiCheckCircleOutline,
  mdiCloseCircleOutline,
} from '@mdi/js'
import Icon from '@mdi/react'

import theme from 'theme_'

export enum Marking {
  None,
  Check,
  Error,
  Warning,
}

const ColorsMap: { [key in Marking]: string } = {
  [Marking.None]: theme.colors.moreGrey,
  [Marking.Check]: theme.colors.successGreen,
  [Marking.Error]: theme.colors.error,
  [Marking.Warning]: theme.colors.statusYellow,
}

const MarkMap: { [key in Marking]: string } = {
  [Marking.None]: mdiCheckboxBlankCircleOutline,
  [Marking.Check]: mdiCheckCircleOutline,
  [Marking.Error]: mdiCloseCircleOutline,
  [Marking.Warning]: mdiAlertCircleOutline,
}

export function Mark(props: {
  className?: string
  marking: Marking
  style?: { [key: string]: any }
}) {
  return (
    <div>
      <Icon
        className={props.className}
        color={ColorsMap[props.marking]}
        path={MarkMap[props.marking]}
        size={0.75}
        style={props.style}
      />
    </div>
  )
}
